import axios from "axios"
import mixpanel from "mixpanel-browser";
import ReactGA from "react-ga4";
import TagManager from 'react-gtm-module'


const initializeApp = () => {
    
    // Setting base URL for all API request via axios
    axios.defaults.baseURL = process.env.REACT_APP_BASE_URL
    console.log(process.env.REACT_APP_BASE_URL)

    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        // dev code
        

    } else {
        // Prod build code

        const tagManagerArgs = {
            gtmId: process.env.REACT_APP_PUBLIC_GTM_TRACKING_ID
        }
         
        TagManager.initialize(tagManagerArgs)

        // Removing console.log from prod
        // console.log = () => {};
        mixpanel.init(process.env.REACT_APP_PUBLIC_MIXPANEL_TOKEN, {debug: false}); 
        ReactGA.initialize(process.env.REACT_APP_PUBLIC_GA_TRACKING_ID);


        // init analytics here
    }

}

export default initializeApp